var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"effect":"dark","placement":"bottom","content":_vm.content,"popper-class":"ellipsis_tooltip_css","open-delay":500,"disabled":!_vm.isOverflow}},[_c('span',{ref:"text",staticClass:"ellipsis"},[_vm._v(" "+_vm._s(_vm.content)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }